import React from 'react'
import { Table } from 'antd'
import { formatMessage } from '@/utils/common'
const AntdTablePage = props => {
  const { columns, dataSource, pagination, ...resProps } = props
  return (
    <Table
      size="small"
      bordered
      dataSource={dataSource.map((data, index) => {
        return { ...data, key: index }
      })}
      columns={columns}
      pagination={
        pagination
          ? {
              current: pagination.currentPage,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: total => `${formatMessage('languageObj.commonLocale.total')} ${total}`
            }
          : false
      }
      {...resProps}
    />
  )
}
export default AntdTablePage
